// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2ctnY","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3cQ4H"};